import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  MentoringProgramGuide,
  MentoringProgramGuideRequirementType,
  MentoringProgramMilestone,
} from 'redux/schemas/models/mentoring-program-guides';

type GetMentorshipProgramGuidesParams = {
  mentoringProgramId: number;
  type?: MentoringProgramGuideRequirementType;
  state?: MentoringProgramMilestone;
  sequence?: number;
};

export const getMentorshipProgramGuides = createAsyncThunk<
  MentoringProgramGuide[],
  GetMentorshipProgramGuidesParams
>(
  'GET_MENTORSHIP_PROGRAM_GUIDES',
  async ({ mentoringProgramId, type, state, sequence }) => {
    const response = await axios.get(
      `/mentorship_programs/${mentoringProgramId}/guides.json`,
      {
        params: {
          type,
          state,
          sequence,
        },
      }
    );
    return response.data.result as MentoringProgramGuide[];
  }
);
